import React, { Fragment, useState, useRef } from 'react'
import _ from 'lodash'
import { statusList } from '../../constants'
import { copyToClipboard } from '../../utils'
import Modal from '../Modal'
import EmailLeads from '../EmailLeads'

let Reports = ({ showEmailLeads = false, clients = [], filteredLeads }) => {
  let [copied, setCopied] = useState(false)
  let tableRef = useRef(null)
  let stats = _(filteredLeads)
    .filter(l => Boolean(l.city))
    .groupBy('city')
    .transform((acc, cityLeads, city) => {
      let statusCounts = _.transform(
        statusList,
        (acc, status) => {
          acc[status] = 0
        },
        {}
      )

      _.each(cityLeads, ({ status }) => {
        statusCounts[status] += 1
      })

      acc.push({
        city,
        total: cityLeads.length,
        fixed: _.filter(cityLeads, { billingType: 'fixed' }).length,
        statusCounts,
      })
    }, [])
    .sortBy('city')
    .value()

  return (
    <div className="mt-2">
      <h6 className="ml-1 d-flex align-items-center">
        Stats by City
        <button
          className="btn btn-sm btn-secondary ml-2"
          disabled={copied}
          title="Copy table data to clipboard"
          onClick={() => {
            copyToClipboard(tableRef.current.innerText)
            setCopied(true)
          }}
        >
          {copied ? (
            <Fragment>
              <i className="fa fa-check" /> Copied
            </Fragment>
          ) : (
            <i className="fa fa-copy" />
          )}
        </button>
        {showEmailLeads && (
          <Modal
            maxWidth="95%"
            title="Email Sent Leads"
            trigger={openModal => (
              <button
                className="btn btn-sm btn-secondary ml-auto"
                onClick={openModal}
              >
                Email Sent Leads
              </button>
            )}
            body={closeModal => (
              <EmailLeads onClose={closeModal} {...{ clients }} />
            )}
          />
        )}
      </h6>
      <table className="table table-striped table-sm" ref={tableRef}>
        <thead>
          <tr>
            <th>City</th>
            <th>Total</th>
            {statusList.map(s => (
              <th key={s}>{_.startCase(s)}</th>
            ))}
            <th>Flat Fee</th>
          </tr>
        </thead>
        <tbody>
          {stats.map(({ city, fixed, total, statusCounts }) => (
            <tr key={city}>
              <td>{city}</td>
              <td>{total}</td>
              {statusList.map(s => (
                <td key={s}>{statusCounts[s]}</td>
              ))}
              <td>{fixed}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Reports
